// extracted by mini-css-extract-plugin
export default {"cls1":"useAttachment-cls1__6D","cls2":"useAttachment-cls2_UZg useAttachment-cls1__6D"};